

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// ADDSTAKENOWSECTIONWITHAPPROVAL
// ADDSTAKENOWSECTIONWITHAPPROVAL


const ADDSTAKENOWSECTIONWITHAPPROVAL= createAsyncThunk(
  "addStakeNowSectionWithApproval/addStakeNowSectionWithApproval",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const addStakeNowSectionWithApprovalSlice = createSlice({
  name: "addStakeNowSectionWithApprovalSlice",
  initialState: {
    addStakeNowSectionWithApproval: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfaddStakeNowSectionWithApproval: (state) => {
        state.addStakeNowSectionWithApproval.loading = false
        state.addStakeNowSectionWithApproval.error = false
        state.addStakeNowSectionWithApproval.data = []
        state.addStakeNowSectionWithApproval.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ADDSTAKENOWSECTIONWITHAPPROVAL.fulfilled, (state, action) => {
      state.addStakeNowSectionWithApproval = {
        ...state.addStakeNowSectionWithApproval,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDSTAKENOWSECTIONWITHAPPROVAL.pending, (state, action) => {
      state.addStakeNowSectionWithApproval = {
        ...state.addStakeNowSectionWithApproval,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDSTAKENOWSECTIONWITHAPPROVAL.rejected, (state, action) => {
      state.addStakeNowSectionWithApproval = {
        ...state.addStakeNowSectionWithApproval,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const addStakeNowSectionWithApprovalAction = {
    ADDSTAKENOWSECTIONWITHAPPROVAL,
};

export { addStakeNowSectionWithApprovalAction };
export default addStakeNowSectionWithApprovalSlice.reducer;
export const {setInitialStateOfaddStakeNowSectionWithApproval} = addStakeNowSectionWithApprovalSlice.actions
